import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header";
import { Button } from "@/components/ui/button";
import { TeamKnowledgeFileDTO } from "@shaarp/common";
import { ColumnDef } from "@tanstack/react-table";
import { FileIcon, XIcon } from "lucide-react";
import DataTableCellTeamKnowledgeFileCreatedBy from "./data-table-cell-team-knowledge-file-created-by";

export const dataTableTeamKnowledgeFilesColumns = (
  t: (key: string) => string,
  onDelete?: (file: TeamKnowledgeFileDTO) => void
): ColumnDef<TeamKnowledgeFileDTO>[] => {
  return [
    {
      id: "name",
      accessorKey: "name",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("team.knowledge.dataTable.columns.name")}
        />
      ),
      cell: ({ row }) => {
        const file: TeamKnowledgeFileDTO = row.original;
        return (
          <a
            className="flex gap-2 items-center"
            href={file.url}
            target="_blank"
          >
            <FileIcon className="size-4! text-muted-foreground" />
            <span className="font-medium">{file.name}</span>
          </a>
        );
      },
    },
    {
      id: "updatedAt",
      accessorKey: "updatedAt",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("team.knowledge.dataTable.columns.updatedAt")}
        />
      ),
      cell: ({ row }) => {
        const file: TeamKnowledgeFileDTO = row.original;
        return (
          <span className="text-muted-foreground">
            {new Date(file.updatedAt).toLocaleString()}
          </span>
        );
      },
    },
    {
      id: "createdBy",
      accessorKey: "createdBy",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("team.knowledge.dataTable.columns.createdBy")}
        />
      ),
      cell: ({ row }) => {
        const file: TeamKnowledgeFileDTO = row.original;
        return <DataTableCellTeamKnowledgeFileCreatedBy file={file} />;
      },
    },
    ...(onDelete
      ? [
          {
            id: "actions",
            header: "",
            cell: ({ row }: { row: any }) => {
              const file: TeamKnowledgeFileDTO = row.original;
              return (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onDelete(file)}
                  className="p-0 w-8 h-8 text-muted-foreground hover:text-destructive"
                >
                  <XIcon className="size-4" />
                </Button>
              );
            },
            enableSorting: false,
          } as ColumnDef<TeamKnowledgeFileDTO>,
        ]
      : []),
  ];
};
